import { isNative, useGetReservationsLazyQuery } from "@stepapp/core";
import { Block, spacing, Typography, useBreakpoints } from "@stepapp/ui";
import { useRouter } from "expo-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, StyleSheet } from "react-native";

import { CityPickerSheet, Testimonials } from "../../src/components";
import PickCityButton from "../../src/components/HomeHeader/PickCityButton";
import { useIsNavReady } from "../../src/hooks";
import { AppStorage } from "../../src/services/AppStorage";
import { ReservationActiveStatuses } from "../../src/store/types";
import Categories from "./Categories";
import ClientSafety from "./ClientSafety";
import FeaturesList from "./FeaturesList";
import HomePageBanner from "./HomePageBanner";
import ServiceBanner from "./ServiceBanner";

let isFirstRender = true;
const Dashboard = () => {
  const isNavReady = useIsNavReady();
  const [modalVisible, setModalVisible] = useState(false);
  const { replace } = useRouter();
  const { md } = useBreakpoints();
  const { t } = useTranslation();

  const isAuthenticated = !!AppStorage().get("token");
  const afterWalkthrough = AppStorage().get("afterWalkthrough");
  const profileInitialised = isAuthenticated || afterWalkthrough;

  const [getReservations, { data }] = useGetReservationsLazyQuery({
    fetchPolicy: "network-only",
    variables: { filter: { status: ReservationActiveStatuses }, isCustomerApp: true },
  });

  useEffect(() => {
    if (!isNavReady) return;

    if (isAuthenticated && isFirstRender) {
      getReservations();
    }

    // if (isNative && !seenChangelog) {
    //   return replace("/app-changelog");
    // }

    if (isNative && !profileInitialised) {
      return replace("/welcome/");
    }
  }, [isAuthenticated, getReservations, profileInitialised, replace, isNavReady]);

  useEffect(() => {
    if (data) {
      isFirstRender = false;
      if (data.listReservations.length > 0) {
        replace("/calendar");
      }
    }
  }, [data, replace]);

  return (
    <Block>
      <ServiceBanner />

      <ScrollView contentContainerStyle={styles.container}>
        {!md && (
          <Block alignCenter row paddingTop={1} paddingBottom={1.25}>
            <Typography variant="newH3">{t("screens.dashboard.title")}</Typography>

            <PickCityButton onPress={() => setModalVisible(true)} />
          </Block>
        )}

        <HomePageBanner />

        <FeaturesList />

        <Categories />

        <ClientSafety />

        <Testimonials />

        <CityPickerSheet isVisible={modalVisible} setModalVisible={setModalVisible} />
      </ScrollView>
    </Block>
  );
};

export default Dashboard;

const styles = StyleSheet.create({
  container: {
    paddingTop: spacing.unit * (isNative ? 1 : 2),
  },
});
